import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Static imports - bundled with the application for immediate availability
import enTranslations from '@/locales/en/common.json';
import deTranslations from '@/locales/de/common.json';
import frTranslations from '@/locales/fr/common.json';
import plTranslations from '@/locales/pl/common.json';
import esTranslations from '@/locales/es/common.json';

const supportedLanguages = ['en', 'de', 'fr', 'pl', 'es'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    ns: ['common'],
    defaultNS: 'common',
    fallbackNS: 'common',
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Strip POSIX/variant suffixes (e.g. "en-US@posix") and other non-BCP47
      // fragments before i18next stores or exposes the language tag. Without
      // this, Intl.DateTimeFormat / toLocaleString throw RangeError on
      // environments (some Linux/CI, misconfigured browsers) whose
      // navigator.language contains an "@" extension.
      convertDetectedLanguage: (lng: string) => {
        if (!lng) return 'en';
        // Drop anything after "@" (POSIX-style variant) and normalise separators.
        const cleaned = lng.split('@')[0].replace(/_/g, '-').trim();
        // Keep only BCP47-safe characters; fall back to primary subtag.
        const safe = /^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})*$/.test(cleaned)
          ? cleaned
          : (cleaned.split('-')[0] || 'en');
        return safe;
      },
    },

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: { common: enTranslations },
      de: { common: deTranslations },
      fr: { common: frTranslations },
      pl: { common: plTranslations },
      es: { common: esTranslations },
    },
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;
export { supportedLanguages };
